import { ItemHelper } from './Item';
import { managerMessages } from './managerMessages';
import { generateReferenceIdentifier } from '../types/identifiers/referenceIdentifier';
import { createNewContent } from './contentBuilder/Content';
import { DefaultRestriction, ItemType } from './ItemType';
export const StartingMessageHelper = {
    build: ({ id, trackingIdentifier, parentId, ...props }) => {
        var _a, _b, _c, _d, _e;
        return ({
            ...ItemHelper.build({ type: ItemType.StartingMessage, trackingIdentifier, id, parentId }),
            title: (_a = props.title) !== null && _a !== void 0 ? _a : managerMessages.defaultTitleStartMessage,
            content: (_b = props.content) !== null && _b !== void 0 ? _b : createNewContent(),
            restriction: (_c = props.restriction) !== null && _c !== void 0 ? _c : DefaultRestriction,
            referenceIdentifier: (_d = props.referenceIdentifier) !== null && _d !== void 0 ? _d : generateReferenceIdentifier(),
            audioAsset: (_e = props.audioAsset) !== null && _e !== void 0 ? _e : null,
        });
    },
};
